import { type PutNftExternalAddressByExternalAddressIdPayload } from '@capsicum/common';
import { useMutation } from '@tanstack/react-query';

import { putExternalAddress } from '../data-access/api';

type EditRecipientData = { id: string; payload: PutNftExternalAddressByExternalAddressIdPayload };

/**
 * @returns editRecipient mutation object
 */
export const useMyCollectibleEditRecipientMutation = () =>
	useMutation({ mutationFn: ({ id, payload }: EditRecipientData) => putExternalAddress(id, payload) });
